import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-both-to-score',
    templateUrl: './default/both-to-score/both-to-score.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class BothToScoreComponent extends UnitsDistributionBase {
  // Used for FOOTBALL_BTTS
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}